module.exports = __webpack_public_path__ + "static/img/iPadPro2020_12.7.028db844.png";